
import React from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";
const PolicyModal=(props)=>{

    const handleClose=()=>Reoverlay.hideModal()
    return <ModalWrapper  onClose={()=>{}}  animation="slideDown" contentContainerClassName="w-11/12 flex flex-col justify-center items-center flex-col md:8/12 lg:w-4/12 p-5 rounded-xl">
        <h1 className="text-xl font-bold mb-1 ">قوانین پرداخت</h1>
        <div className="border-t  w-full mt-3 "/>
        <div className="max-h-52 overflow-auto">

            <ul className="text-sm list-disc ">

                <li className="mb-2 mt-3 ">با توجه به استفاده شما از خدمات ما، لطفاً شرایط و ضوابط زیر را به دقت مطالعه کنید.
                    با ادامه فرآیند پرداخت، شما موافقت خود را با این شرایط و ضوابط اعلام می‌کنید.
                </li>

                <li className="mb-2">
                    <strong>سوءاستفاده و کلاه‌برداری : </strong>
                    در صورت تشخیص هرگونه سوءاستفاده، تخلف یا کلاه‌برداری، اطلاعات کاربر طبق قوانین اپلیکیشن دیوار و با
                    هماهنگی مراجع قانونی در اختیار شاکی قرار خواهد گرفت.

                </li>
                <li className="mb-2">
                    <strong> قبول شرایط و ضوابط : </strong>
                    با تایید و ادامه فرآیند پرداخت، شما موافقت خود را با تمامی شرایط و ضوابط این سرویس را اعلام می‌کنید
                    و به آنها ملزم می‌شوید.
                </li>
                <li className="mb-2">
                    <strong>عدم انصراف از پرداخت : </strong>
                    پس از تایید پرداخت، شما موافقت می‌کنید که از حق انصراف از پرداخت خودداری کنید مگر اینکه در شرایط
                    خاصی که در این متن ذکر شده است، امکان آن فراهم باشد.
                </li>
                <li className="mb-2">
                    <strong> تضمین امنیت پرداخت : </strong>
                    ما تمام تلاش خود را برای اطمینان از امنیت فرآیند پرداخت شما انجام می‌دهیم. اطلاعات مالی شما با
                    استفاده از روش‌های امنیتی مدرن محافظت می‌شود.
                </li>
                <li className="mb-2">
                    <strong>مسئولیت‌های مالی : </strong>
                    شما به عنوان پرداخت‌کننده مسئولیت کلیه هزینه‌ها و مالیات‌های مرتبط با این پرداخت را بر عهده دارید.
                </li>
                <li className="mb-2">
                    <strong>تایید رضایت : </strong>
                    با تایید پرداخت، شما تایید می‌کنید که شرایط و ضوابط ما را مطالعه کرده و با آنها موافقت دارید.
                </li>

            </ul>
            <p className="text-sm">
                لطفاً توجه داشته باشید که پس از پرداخت، امکان انصراف از پرداخت ممکن نیست مگر در شرایط خاصی که ممکن است
                در این متن یا در صفحه پرداخت ذکر شده باشد.
            </p>
        </div>
        <Button rounded="rounded-lg" onClick={handleClose} type="button" className="mt-2 text-sm  w-full" theme="light">بستن</Button>
    </ModalWrapper>
}
export default PolicyModal;